import {
    IEntity,
    IEntityAttribute,
    IEntityAttributeChangeEvent,
    IEntityAttributeSearchOptions
} from "../PA.MD.Core/PA.MD.IF.Entity";
import {
    WB_AttributeTypeRow,
    WB_CustomerAttributeRow,
    WB_EntityRow,
    WB_FinishedProductRow,
    WB_FinishedProductSalesAreaRow,
    WB_ProductAttributeRow,
    WB_ProductGroupRow, WB_ProductGroupSalesAreaRow,
    WB_ProductTypeRow,
    WB_SalesAreaRow
} from "../PA.Core/PAdbSchemaRows";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {PAdbContext} from "../PA.Core/PAdbContext";
import * as _ from "lodash"
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {
    esWB_Finished_Product,
    esWB_Finished_Product_SalesArea, esWB_Product_Attribute, esWB_Product_Group,
    esWB_Product_Group_SalesArea, esWB_SalesArea
} from "../PA.Core/PAdbSchema";
import {EntityTypeUtils} from "./EntityTypeUtils";
import {BehaviorSubject} from "rxjs";
import {CustomAttribute} from "./CustomAttribute";
import {CoreAttribute} from "./CoreAttribute";
import {EntityUtils} from "./EntityUtils";

const dctSalesAreaFieldsByMapper = {
    [esWB_Product_Group_SalesArea]: "WB_SALESAREA_ID",
    [esWB_Finished_Product_SalesArea]: "WB_SALESAREA_ID"
}

export class ProductEntity
    implements IEntity {
    constructor(opts: { productRow?: WB_FinishedProductRow, productGroupRow?: WB_ProductGroupRow }) {
        let prdRow = opts?.productRow || opts?.productGroupRow
        this.prdRow = prdRow
        this._dbContext = <PAdbContext>prdRow.dataStore()
        this.loadMessageProvider = new MessageProvider()
        this.validateMessageProvider = new MessageProvider()
        this._bLoaded = false
        this._bSaved = false
        this._bDeleted = false
        this.onLoadComplete = undefined
        this.dctAttributeMByWbId = {}
        this.dctAttributeMById = {}
        this.dctAttributesByAttrMId = {}
        this.productTypeRow = prdRow.WB_ProductTypeRow
        this.entityRow = undefined
        this.entityAttributesChanged = new BehaviorSubject<IEntityAttributeChangeEvent>(undefined)
        this.entityAttributes = []

    }

    private prdRow: WB_FinishedProductRow | WB_ProductGroupRow
    private _dbContext: PAdbContext
    private loadMessageProvider: MessageProvider
    private entityAttributes: IEntityAttribute[];
    private validateMessageProvider: MessageProvider
    private _bLoaded: boolean
    private _bDeleted: boolean;
    private _bSaved: boolean;
    private onLoadComplete: Promise<void>
    private productTypeRow: WB_ProductTypeRow
    private entityRow: WB_EntityRow

    private dctAttributeMByWbId: { [wbId: number]: WB_AttributeTypeRow }
    private dctAttributeMById: { [attrMId: string]: WB_AttributeTypeRow }
    private dctAttributesByAttrMId: { [attrMId: string]: IEntityAttribute[] }
    private entityAttributesChanged: BehaviorSubject<IEntityAttributeChangeEvent>

    get dbContext(): PAdbContext {
        return this._dbContext
    }

    get wbMasterDataSetId(): number {
        return this.prdRow.cif.WB_MDSET_ID
    }

    get wb_id(): number {
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                return this.prdRow.cif.WB_PROD_ID
            case esWB_Product_Group:
                return this.prdRow.cif.WB_PRDGRP_ID
        }
        return undefined
    }

    get id_ui(): string {
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                return this.prdRow.cif.PRODUCT_ID
            case esWB_Product_Group:
                return this.prdRow.cif.PRODUCT_GROUP_ID
        }
        return undefined
    }

    get key_set(): string {
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                return this.prdRow.cif.PRODUCT_SET_ID
            case esWB_Product_Group:
                return this.prdRow.cif.PRODUCT_GROUP_SET_ID
        }
        return undefined
    }

    get name(): string {
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                return this.prdRow.cif.PRODUCT_NAME
            case esWB_Product_Group:
                return this.prdRow.cif.PRODUCT_GROUP_NAME
        }
        return undefined
    }

    get mapperName(): string {
        return this.prdRow._mapper().name
    }

    get LoadMessageProvider(): MessageProvider {
        return this.loadMessageProvider
    };

    get EntityAttributesChanged(): BehaviorSubject<IEntityAttributeChangeEvent> {
        return this.entityAttributesChanged
    }

    OnLoadComplete(): Promise<void> {
        const self = this
        if (!_.isEmpty(this.onLoadComplete))
            return this.onLoadComplete

        let rv = (async () => {

            try {
                this.prdRow.WB_ProductTypeRow
                let wbId = this.prdRow.WB_ProductTypeRow.cif.WB_PRDM_ID


                let entityRow = await EntityTypeUtils.getEntityTypeRowByMeta("WB_PrdM", wbId)

                // Get the Attributes..
                let arrAtt = await EntityTypeUtils.getEntityAttributeTypes(entityRow.cif.WB_ENTITY_ID)

                _.forEach(arrAtt, (a) => {
                    let wbId = a.cif.WB_ATTRIBUTEM_ID
                    let Id = a.cif.ATTRIBUTEM_ID
                    if (!(wbId in self.dctAttributeMByWbId)) {
                        self.dctAttributeMByWbId[wbId] = a
                    }

                    if (!(Id in self.dctAttributeMById)) {
                        self.dctAttributeMById[Id] = a
                    }

                })

                let coreAttrs = await EntityTypeUtils.getCoreAttributeTypes("Product")
                let prdRowMapperName = this.prdRow._mapper().name

                _.forEach(coreAttrs, (a) => {
                    let wbId = a.cif.WB_ATTRIBUTEM_ID
                    let Id = a.cif.ATTRIBUTEM_ID
                    if (a.cif.CORE_STARTMAPPER != prdRowMapperName)
                        return

                    if (!(wbId in self.dctAttributeMByWbId)) {
                        self.dctAttributeMByWbId[wbId] = a
                    }

                    if (!(Id in self.dctAttributeMById)) {
                        self.dctAttributeMById[Id] = a
                    }

                })


                // Create Custom Attributes
                _.forEach(self.prdRow.WB_ProductAttributeRows, (a) => {
                    if (!a.isActive)
                        return
                    let at = a.WB_AttributeTypeRow
                    if (_.isEmpty(at))
                        return
                    let ca = new CustomAttribute(self, at, a)

                    self.entityAttributes.push(ca)
                    self.indexAttribute(ca)
                })

                // Create Core Attributes
                for (let coreAttrM of coreAttrs) {
                    //-- Use the Path to determine the dataRecords.
                    let startMapper = coreAttrM.cif.CORE_STARTMAPPER
                    let rowMapper = coreAttrM.cif.CORE_ROWMAPPER

                    let valueFieldName = coreAttrM.cif.CORE_VALUE_FIELDNAME
                    let path = coreAttrM.cif.CORE_PATH.trim()

                    if (startMapper != prdRowMapperName)
                        continue

                    let tgtEntity: WB_EntityRow = undefined
                    if (coreAttrM.cif.DATATYPE == "entity") {
                        tgtEntity = await EntityTypeUtils.getEntityTypeRowByLogicalKey(self.wbMasterDataSetId, coreAttrM.cif.ENTITY_DIMENSION, coreAttrM.cif.CORE_ENTITY_ID_TARGET)
                    }

                    if ((rowMapper == startMapper) && (_.isEmpty(path))) {
                        let ca = new CoreAttribute(self, coreAttrM, self.prdRow, tgtEntity, valueFieldName)
                        self.entityAttributes.push(ca)
                        self.indexAttribute(ca)
                        continue
                    }

                    // findDataRows related to Path, may be one

                    let arrPathItems = path.split(".")

                    function findRows(searchRows: ESRecord[], pPath: string[]): ESRecord[] {
                        if (_.isEmpty(pPath))
                            return searchRows
                        let nextRows: ESRecord[] = []
                        let fieldName = pPath.shift()
                        _.forEach(searchRows, (a) => {
                            let fieldVal = (<any>a)[fieldName]
                            if (_.isArray(fieldVal)) {
                                _.forEach(fieldVal, (aRow: ESRecord) => {
                                    if (!_.isObject(aRow))
                                        return
                                    if (aRow.isActive)
                                        nextRows.push(aRow)
                                })
                            } else if (_.isObjectLike(fieldVal)) {
                                if (!fieldVal.isActive)
                                    return
                                nextRows.push(fieldVal)
                            } else {
                                // Element not found
                            }
                        })

                        return findRows(nextRows, _.clone(pPath))
                    }

                    let foundRows = findRows([self.prdRow], arrPathItems)
                    for (let aRow of foundRows) {
                        let aCoreAttr = new CoreAttribute(self, coreAttrM, aRow, tgtEntity,
                            coreAttrM.cif.CORE_VALUE_FIELDNAME,
                            coreAttrM.cif.CORE_SALESAREA_FIELDNAME,
                            coreAttrM.cif.CORE_STARTDT_FIELDNAME,
                            coreAttrM.cif.CORE_ENDDT_FIELDNAME)
                        self.entityAttributes.push(aCoreAttr)
                        self.indexAttribute(aCoreAttr)
                    }
                }

                self._bLoaded = true
            } catch (err) {
                self._bLoaded = false
            }

        })();

        return rv
    }

    get bLoaded(): boolean {
        return this._bLoaded
    }

    get EntityAttributes(): IEntityAttribute[] {
        return this.entityAttributes
    }

    get AttributeTypes(): WB_AttributeTypeRow[] {
        return _.values(this.dctAttributeMByWbId)
    }

    async createAttribute(attrType: WB_AttributeTypeRow | number): Promise<IEntityAttribute> {
        let wbAttrMRow: WB_AttributeTypeRow = undefined
        if (_.isNumber(attrType) || _.isString(attrType)) {
            wbAttrMRow = this.dctAttributeMByWbId[<any>attrType]
        }
        if (_.isEmpty(wbAttrMRow) && !_.isEmpty(attrType)) {
            wbAttrMRow = <any>attrType
        }

        if (_.isEmpty(wbAttrMRow) || !wbAttrMRow?.isActive)
            return

        if (wbAttrMRow.bCoreInd)
            return

        let aNewRow: WB_ProductAttributeRow = <any>await this.dbContext.createRecordWithKey(esWB_Product_Attribute)
        aNewRow.setDefaults()
        aNewRow.cif.WB_ATTRIBUTEM_ID = wbAttrMRow.cif.WB_ATTRIBUTEM_ID
        aNewRow.WB_AttributeTypeRow = wbAttrMRow
        aNewRow.cif.WB_SALESAREA_ID = 0
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                aNewRow.cif.WB_PROD_ID = this.prdRow.cif.WB_PROD_ID
                aNewRow.WB_ProductRow = <any>this.prdRow
                break
            case esWB_Product_Group:
                aNewRow.cif.WB_PRDGRP_ID = this.prdRow.cif.WB_PRDGRP_ID
                aNewRow.WB_ProductGroupRow = <any>this.prdRow
                break
        }
        this.dbContext.add(esWB_Product_Attribute, aNewRow)

        let ea = new CustomAttribute(this, wbAttrMRow, aNewRow)
        this.entityAttributes.push(ea)
        this.indexAttribute(ea)
        this.EntityAttributesChanged.next({Entity: this, Attribute: ea})
        return ea
    }


    getEntityAttribute(attributeTypeId: string, options?: IEntityAttributeSearchOptions): IEntityAttribute {
        return EntityUtils.searchAttributes(this,
            this.dctAttributesByAttrMId[attributeTypeId] || [],
            options)
    }

    private indexAttribute(ea: IEntityAttribute): void {
        if (_.isEmpty(ea) || _.isEmpty(ea.type))
            return

        let attrMId = ea.type.cif.ATTRIBUTEM_ID
        if (!(attrMId in this.dctAttributesByAttrMId))
            this.dctAttributesByAttrMId[attrMId] = []

        this.dctAttributesByAttrMId[attrMId].push(ea)
    }

    get ValidateMessageProvider(): MessageProvider {
        return this.validateMessageProvider
    };

    async Validate(): Promise<void> {
        this.ValidateMessageProvider.clearMessages()

        // Call re-usable validation that checks for duplicate attributes
        await EntityUtils.ValidateCustomAttributes(this)

    }

    async Save(bBatch?: boolean, options?: { bSkipValidations?: boolean, dbContext?: PAdbContext }): Promise<void> {
        const self = this
        let dbContext = options?.dbContext || this._dbContext

        // Only Save the Custom Attributes
        let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
        if (bBatch) {
            saveFunction = dbContext.SaveBatch.bind(dbContext)
        } else {
            saveFunction = dbContext.Save.bind(dbContext)
        }

        self.ValidateMessageProvider.clearMessages()
        if (!(options?.bSkipValidations))
            await self.Validate()

        if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
            self._bSaved = false;
            return
        }
        // Just Save the Custom Attributes

        await saveFunction(esWB_Product_Attribute, self.prdRow.WB_ProductAttributeRows)
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                let prdRow = <WB_FinishedProductRow>this.prdRow
                await  saveFunction(esWB_Finished_Product, prdRow)
                await saveFunction(esWB_Finished_Product_SalesArea, prdRow.WB_FinishedProductSalesAreaRows)
                break;
            case esWB_Product_Group:
                let prdGrpRow = <WB_ProductGroupRow>this.prdRow
                await saveFunction(esWB_Product_Group, prdGrpRow)
                await saveFunction(esWB_Product_Group_SalesArea, prdGrpRow.WB_ProductGroupSalesAreaRows)
                break;
        }

        if (bBatch) {
            dbContext.addBatchCompleteListener(() => {
                self._bSaved = true;
            })
        } else {
            self._bSaved = true;
        }

    }

    get bSaved(): boolean {
        return this._bSaved
    }


    async Delete(bSaveNow: boolean, options?: { bSkipValidations?: boolean }): Promise<void> {
        // Do nothing, only delete through the BO..
        this._bDeleted = true
    }

    get bDeleted(): boolean {
        return this._bDeleted
    }


    setName(sName: string) {
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                this.prdRow.cif.PRODUCT_NAME = sName
                break;
            case esWB_Product_Group:
                this.prdRow.cif.PRODUCT_GROUP_NAME = sName
                break
        }
    }

    get  bHasSalesAreas(): boolean {
        return true
    }


    get SalesAreas(): WB_SalesAreaRow[] {
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                let prdRow = <WB_FinishedProductRow>this.prdRow
                return _.map(
                    _.filter(prdRow.WB_FinishedProductSalesAreaRows,(a) => a.isActive && !_.isEmpty(a.WB_SalesAreaRow)),
                    aRow => aRow.WB_SalesAreaRow)
            case esWB_Product_Group:
                let prdGrpRow = <WB_ProductGroupRow>this.prdRow
                return _.map(
                    _.filter(prdGrpRow.WB_ProductGroupSalesAreaRows,(a) => a.isActive && !_.isEmpty(a.WB_SalesAreaRow)),
                    aRow => aRow.WB_SalesAreaRow)

        }
        return []
    }

    async addSalesArea(wbSalesAreaId: number): Promise<void> {
        if (_.filter(this.SalesAreas, sa=>sa.cif.WB_SALESAREA_ID==wbSalesAreaId).length)
            return

        let aSARow: WB_SalesAreaRow = await this.dbContext.find(esWB_SalesArea, wbSalesAreaId)

        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                let prdRow = <WB_FinishedProductRow>this.prdRow
                let prodSARow: WB_FinishedProductSalesAreaRow = <WB_FinishedProductSalesAreaRow>await this._dbContext.createRecordWithKey(esWB_Finished_Product_SalesArea)
                prodSARow.setDefaults()
                prodSARow.cif.WB_PROD_ID = prdRow.cif.WB_PROD_ID
                prodSARow.cif.WB_SALESAREA_ID = wbSalesAreaId
                prodSARow.WB_SalesAreaRow = aSARow
                await this.dbContext.add(esWB_Finished_Product_SalesArea, prodSARow)
                return
            case esWB_Product_Group:
                let prdGrpRow = <WB_ProductGroupRow>this.prdRow
                let prdGrpSARow: WB_ProductGroupSalesAreaRow = <WB_ProductGroupSalesAreaRow>await this._dbContext.createRecordWithKey(esWB_Product_Group_SalesArea)
                prdGrpSARow.setDefaults()
                prdGrpSARow.cif.WB_PRDGRP_ID = prdGrpRow.cif.WB_PRDGRP_ID
                prdGrpSARow.cif.WB_SALESAREA_ID = wbSalesAreaId
                prdGrpSARow.WB_SalesAreaRow = aSARow
                await this.dbContext.add(esWB_Product_Group_SalesArea, prdGrpSARow)
                return

        }
    }

    removeSalesArea(wbSalesAreaId: number): Promise<void> {
        switch (this.prdRow._mapper().name) {
            case esWB_Finished_Product:
                let prdRow = <WB_FinishedProductRow>this.prdRow
                for (let row of prdRow.WB_FinishedProductSalesAreaRows) {
                    if (row.cif.WB_SALESAREA_ID == wbSalesAreaId)
                        row.markDeleted()
                }
                return
            case esWB_Product_Group:
                let prdGrpRow = <WB_ProductGroupRow>this.prdRow
                for (let row of prdGrpRow.WB_ProductGroupSalesAreaRows) {
                    if (row.cif.WB_SALESAREA_ID == wbSalesAreaId)
                        row.markDeleted()
                }
                return

        }
        return

    }


}